import GanttChartSchema from 'sitemodel/schema/components/GanttChartSchema'
import schemaToReactType from 'sitemodel/schema/util/schemaToReactType'
import schemaToTypeGuard from 'sitemodel/schema/util/schemaToTypeGuard'

export type GanttChartProps = schemaToReactType<typeof GanttChartSchema>

export const GanttChartTypeGuard = schemaToTypeGuard(GanttChartSchema)
